<div class="container-fluid">
  <div class="row">
    <footer>
      <div>
        <p class="copyright">© 2026 Vaillant</p>
        <nav>
          <ul>
            @for (link of getConfig().footerLinks; track link) {
              <li class="footer-link">
                <a target="_blank" href="{{ link.url }}">{{ getTranslator().tr(link.caption) }}</a>
              </li>
            }
          </ul>
        </nav>
      </div>
    </footer>
  </div>
</div>